import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import * as saveAs from 'file-saver';
import { ApiService } from '../../../../../@core/service/api.service';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { DownloadConfig } from '../../../document/document-printer/document-printer.component';
import { CommonPrinter } from '../commonPrinter';

@Component({
  selector: 'ngx-popup-report',
  templateUrl: './popup-report.component.html',
  styleUrls: ['./popup-report.component.scss'],
})
export class PopupReportComponent {

  @Input() searches: any;
  @Output() close = new EventEmitter<void>();

  @ViewChildren('reportsPrinter') reportsPrinter: QueryList<ElementRef>;

  constructor(private api: ApiService, private toastr: NbToastrService, public data: SharedDataService) { }

  onClose() {
    this.close.emit();
  }

  onDownloadPdf(search, idx) {
    return new Promise<void>(resolve => {
      const config = new DownloadConfig;
      // console.log('reports printer', this.reportsPrinter.toArray());
      config.html = (this.reportsPrinter.toArray()[idx] as any).elRef.nativeElement.innerHTML;
      config.css = 'reports-printer.css';
      config.orientation = search.orders.orientation === 'portrait' ? 'Portrait' : 'Landscape';
      setTimeout(() => resolve(), 20000); // 20s timeout
      this.api.getDocumentFile('/api/v1/document_report/pdf', config).subscribe(res => {
        saveAs(res, CommonPrinter.getPDFFilename('orders', search) + '.pdf')
        resolve();
      });
    });
  }


}
